import { Box, Tooltip, useTheme } from '@mui/material';
import { MdOutlineCancel, MdOutlinePersonOutline, MdOutlineStarBorder } from 'react-icons/md';
import type { IconType } from 'react-icons';
import type { ContactCategory } from 'apis/business/agent/contact/types';

export type ContactCategoryOption = {
  value: ContactCategory;
  label: string;
  Icon: IconType;
  colorKey: 'primary' | 'warning' | 'error';
};

export const CONTACT_CATEGORY_OPTIONS: ContactCategoryOption[] = [
  { value: 'vip', label: 'VIP', Icon: MdOutlineStarBorder, colorKey: 'warning' },
  { value: 'general', label: 'General', Icon: MdOutlinePersonOutline, colorKey: 'primary' },
  { value: 'spam', label: 'Spam', Icon: MdOutlineCancel, colorKey: 'error' }
];

export function getContactCategoryOption(category?: ContactCategory | null): ContactCategoryOption | undefined {
  if (!category) return undefined;
  return CONTACT_CATEGORY_OPTIONS.find((option) => option.value === category);
}

type ContactCategoryIconProps = {
  category?: ContactCategory | null;
  size?: number;
  showTooltip?: boolean;
};

export function ContactCategoryIcon({ category, size = 20, showTooltip = false }: ContactCategoryIconProps) {
  const theme = useTheme();
  const option = getContactCategoryOption(category);

  if (!option) return null;

  const color = theme.palette[option.colorKey].main;
  const icon = <option.Icon size={size} color={color} aria-label={option.label} />;

  if (!showTooltip) {
    return (
      <Box component='span' display='inline-flex' alignItems='center' lineHeight={0}>
        {icon}
      </Box>
    );
  }

  return (
    <Tooltip title={option.label} placement='top'>
      <Box component='span' display='inline-flex' alignItems='center' lineHeight={0}>
        {icon}
      </Box>
    </Tooltip>
  );
}
